import HomeHero from "./HomeHero"
import { Form } from "."
import HomeCards from "./HomeCards"
import HomeSlidesOne from "./HomeSlidesOne"
import HomeSlidesTwo from "./HomeSlidesTwo"

export default function Home() {
  return (
    <>
      <HomeHero />
      <HomeCards />
      <HomeSlidesOne />
      <HomeSlidesTwo />

      <div className="bg-blue py-10 px-5 lg:py-20 2xl:px-0">
        <article className="xl:max-w-6xl xl:mx-auto">
          <h2 className="text-white text-3xl lg:text-5xl mb-5 lg:mb-10 lg:leading-snug">
            Let's take your business
            <span className="md:block"> to a new level.</span>
          </h2>
          <Form />
        </article>
      </div>
    </>
  )
}
